/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TestHub, TestHubInterface, IRelayHub } from "../TestHub";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IStakeManager",
        name: "_stakeManager",
        type: "address",
      },
      {
        internalType: "address",
        name: "_penalizer",
        type: "address",
      },
      {
        internalType: "address",
        name: "_batchGateway",
        type: "address",
      },
      {
        internalType: "address",
        name: "_relayRegistrar",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "maxWorkerCount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gasReserve",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "postOverhead",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gasOverhead",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minimumUnstakeDelay",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "devAddress",
            type: "address",
          },
          {
            internalType: "uint8",
            name: "devFee",
            type: "uint8",
          },
          {
            internalType: "uint80",
            name: "baseRelayFee",
            type: "uint80",
          },
          {
            internalType: "uint16",
            name: "pctRelayFee",
            type: "uint16",
          },
        ],
        internalType: "struct IRelayHub.RelayHubConfig",
        name: "_config",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
    ],
    name: "AbandonedRelayManagerBalanceEscheated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "paymaster",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Deposited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "deprecationTime",
        type: "uint256",
      },
    ],
    name: "HubDeprecated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "eth",
        type: "uint256",
      },
    ],
    name: "Received",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "maxWorkerCount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gasReserve",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "postOverhead",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gasOverhead",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minimumUnstakeDelay",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "devAddress",
            type: "address",
          },
          {
            internalType: "uint8",
            name: "devFee",
            type: "uint8",
          },
          {
            internalType: "uint80",
            name: "baseRelayFee",
            type: "uint80",
          },
          {
            internalType: "uint16",
            name: "pctRelayFee",
            type: "uint16",
          },
        ],
        indexed: false,
        internalType: "struct IRelayHub.RelayHubConfig",
        name: "config",
        type: "tuple",
      },
    ],
    name: "RelayHubConfigured",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "newRelayWorkers",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "workersCount",
        type: "uint256",
      },
    ],
    name: "RelayWorkersAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minimumStake",
        type: "uint256",
      },
    ],
    name: "StakingTokenDataChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "amount0",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "amount1",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "uint160",
        name: "sqrtPriceX96",
        type: "uint160",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "liquidity",
        type: "uint128",
      },
      {
        indexed: false,
        internalType: "int24",
        name: "tick",
        type: "int24",
      },
    ],
    name: "Swap",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "gasUseWithoutPost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "gasJustPost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenActualCharge",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ethActualCharge",
        type: "uint256",
      },
    ],
    name: "TokensCharged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "paymaster",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "relayRequestID",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "relayWorker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "innerGasUsed",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "reason",
        type: "bytes",
      },
    ],
    name: "TransactionRejectedByPaymaster",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "relayWorker",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "relayRequestID",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "paymaster",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "enum IRelayHub.RelayCallStatus",
        name: "status",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "charge",
        type: "uint256",
      },
    ],
    name: "TransactionRelayed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "enum IRelayHub.RelayCallStatus",
        name: "status",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "returnValue",
        type: "bytes",
      },
    ],
    name: "TransactionResult",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "tokenIn",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256",
      },
    ],
    name: "UniswapReverted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "src",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "wad",
        type: "uint256",
      },
    ],
    name: "Withdrawal",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "dest",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Withdrawn",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "newRelayWorkers",
        type: "address[]",
      },
    ],
    name: "addRelayWorkers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "aggregateGasleft",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "gasUsed",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "transactionCalldataGasUsed",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "relayWorker",
            type: "address",
          },
          {
            internalType: "address",
            name: "paymaster",
            type: "address",
          },
          {
            internalType: "address",
            name: "forwarder",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "paymasterData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "clientId",
            type: "uint256",
          },
        ],
        internalType: "struct GsnTypes.RelayData",
        name: "relayData",
        type: "tuple",
      },
    ],
    name: "calculateCharge",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "charge",
        type: "uint256",
      },
    ],
    name: "calculateDevCharge",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "depositFor",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_deprecationTime",
        type: "uint256",
      },
    ],
    name: "deprecateHub",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
    ],
    name: "escheatAbandonedRelayBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getBatchGateway",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getConfiguration",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "maxWorkerCount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gasReserve",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "postOverhead",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gasOverhead",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minimumUnstakeDelay",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "devAddress",
            type: "address",
          },
          {
            internalType: "uint8",
            name: "devFee",
            type: "uint8",
          },
          {
            internalType: "uint80",
            name: "baseRelayFee",
            type: "uint80",
          },
          {
            internalType: "uint16",
            name: "pctRelayFee",
            type: "uint16",
          },
        ],
        internalType: "struct IRelayHub.RelayHubConfig",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCreationBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getDeprecationTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "getMinimumStakePerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getPenalizer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getRelayRegistrar",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getStakeManager",
    outputs: [
      {
        internalType: "contract IStakeManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "manager",
        type: "address",
      },
    ],
    name: "getWorkerCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "worker",
        type: "address",
      },
    ],
    name: "getWorkerManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "domainSeparatorName",
        type: "string",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "from",
                type: "address",
              },
              {
                internalType: "address",
                name: "to",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "value",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "gas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
              },
              {
                internalType: "bytes",
                name: "data",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "validUntilTime",
                type: "uint256",
              },
            ],
            internalType: "struct IForwarder.ForwardRequest",
            name: "request",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxPriorityFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "transactionCalldataGasUsed",
                type: "uint256",
              },
              {
                internalType: "address",
                name: "relayWorker",
                type: "address",
              },
              {
                internalType: "address",
                name: "paymaster",
                type: "address",
              },
              {
                internalType: "address",
                name: "forwarder",
                type: "address",
              },
              {
                internalType: "bytes",
                name: "paymasterData",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "clientId",
                type: "uint256",
              },
            ],
            internalType: "struct GsnTypes.RelayData",
            name: "relayData",
            type: "tuple",
          },
        ],
        internalType: "struct GsnTypes.RelayRequest",
        name: "relayRequest",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "approvalData",
        type: "bytes",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "acceptanceBudget",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preRelayedCallGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "postRelayedCallGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "calldataSizeLimit",
            type: "uint256",
          },
        ],
        internalType: "struct IPaymaster.GasAndDataLimits",
        name: "gasAndDataLimits",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "totalInitialGas",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxPossibleGas",
        type: "uint256",
      },
    ],
    name: "innerRelayCall",
    outputs: [
      {
        internalType: "enum IRelayHub.RelayCallStatus",
        name: "",
        type: "uint8",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isDeprecated",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
    ],
    name: "isRelayEscheatable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
    ],
    name: "onRelayServerRegistered",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayWorker",
        type: "address",
      },
      {
        internalType: "address payable",
        name: "beneficiary",
        type: "address",
      },
    ],
    name: "penalize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "domainSeparatorName",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "maxAcceptanceBudget",
        type: "uint256",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "from",
                type: "address",
              },
              {
                internalType: "address",
                name: "to",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "value",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "gas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
              },
              {
                internalType: "bytes",
                name: "data",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "validUntilTime",
                type: "uint256",
              },
            ],
            internalType: "struct IForwarder.ForwardRequest",
            name: "request",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxPriorityFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "transactionCalldataGasUsed",
                type: "uint256",
              },
              {
                internalType: "address",
                name: "relayWorker",
                type: "address",
              },
              {
                internalType: "address",
                name: "paymaster",
                type: "address",
              },
              {
                internalType: "address",
                name: "forwarder",
                type: "address",
              },
              {
                internalType: "bytes",
                name: "paymasterData",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "clientId",
                type: "uint256",
              },
            ],
            internalType: "struct GsnTypes.RelayData",
            name: "relayData",
            type: "tuple",
          },
        ],
        internalType: "struct GsnTypes.RelayRequest",
        name: "relayRequest",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "approvalData",
        type: "bytes",
      },
    ],
    name: "relayCall",
    outputs: [
      {
        internalType: "bool",
        name: "paymasterAccepted",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "charge",
        type: "uint256",
      },
      {
        internalType: "enum IRelayHub.RelayCallStatus",
        name: "status",
        type: "uint8",
      },
      {
        internalType: "bytes",
        name: "returnValue",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "maxWorkerCount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gasReserve",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "postOverhead",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gasOverhead",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minimumUnstakeDelay",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "devAddress",
            type: "address",
          },
          {
            internalType: "uint8",
            name: "devFee",
            type: "uint8",
          },
          {
            internalType: "uint80",
            name: "baseRelayFee",
            type: "uint80",
          },
          {
            internalType: "uint16",
            name: "pctRelayFee",
            type: "uint16",
          },
        ],
        internalType: "struct IRelayHub.RelayHubConfig",
        name: "_config",
        type: "tuple",
      },
    ],
    name: "setConfiguration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20[]",
        name: "token",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "minimumStake",
        type: "uint256[]",
      },
    ],
    name: "setMinimumStakes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
    ],
    name: "verifyRelayManagerStaked",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "versionHub",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "dest",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable[]",
        name: "dest",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amount",
        type: "uint256[]",
      },
    ],
    name: "withdrawMultiple",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "from",
                type: "address",
              },
              {
                internalType: "address",
                name: "to",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "value",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "gas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
              },
              {
                internalType: "bytes",
                name: "data",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "validUntilTime",
                type: "uint256",
              },
            ],
            internalType: "struct IForwarder.ForwardRequest",
            name: "request",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxPriorityFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "transactionCalldataGasUsed",
                type: "uint256",
              },
              {
                internalType: "address",
                name: "relayWorker",
                type: "address",
              },
              {
                internalType: "address",
                name: "paymaster",
                type: "address",
              },
              {
                internalType: "address",
                name: "forwarder",
                type: "address",
              },
              {
                internalType: "bytes",
                name: "paymasterData",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "clientId",
                type: "uint256",
              },
            ],
            internalType: "struct GsnTypes.RelayData",
            name: "relayData",
            type: "tuple",
          },
        ],
        internalType: "struct GsnTypes.RelayRequest",
        name: "relayRequest",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "approvalData",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "maxPossibleGas",
        type: "uint256",
      },
    ],
    name: "callPreRC",
    outputs: [
      {
        internalType: "bytes",
        name: "context",
        type: "bytes",
      },
      {
        internalType: "bool",
        name: "revertOnRecipientRevert",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IPaymaster",
        name: "paymaster",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "context",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "gasUseWithoutPost",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "transactionCalldataGasUsed",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "relayWorker",
            type: "address",
          },
          {
            internalType: "address",
            name: "paymaster",
            type: "address",
          },
          {
            internalType: "address",
            name: "forwarder",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "paymasterData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "clientId",
            type: "uint256",
          },
        ],
        internalType: "struct GsnTypes.RelayData",
        name: "relayData",
        type: "tuple",
      },
    ],
    name: "callPostRC",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TestHubConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TestHubConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TestHub__factory extends ContractFactory {
  constructor(...args: TestHubConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _stakeManager: string,
    _penalizer: string,
    _batchGateway: string,
    _relayRegistrar: string,
    _config: IRelayHub.RelayHubConfigStruct,
    overrides?: Overrides & { from?: string }
  ): Promise<TestHub> {
    return super.deploy(
      _stakeManager,
      _penalizer,
      _batchGateway,
      _relayRegistrar,
      _config,
      overrides || {}
    ) as Promise<TestHub>;
  }
  override getDeployTransaction(
    _stakeManager: string,
    _penalizer: string,
    _batchGateway: string,
    _relayRegistrar: string,
    _config: IRelayHub.RelayHubConfigStruct,
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _stakeManager,
      _penalizer,
      _batchGateway,
      _relayRegistrar,
      _config,
      overrides || {}
    );
  }
  override attach(address: string): TestHub {
    return super.attach(address) as TestHub;
  }
  override connect(signer: Signer): TestHub__factory {
    return super.connect(signer) as TestHub__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestHubInterface {
    return new utils.Interface(_abi) as TestHubInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestHub {
    return new Contract(address, _abi, signerOrProvider) as TestHub;
  }
}
